import React from "react";

export const Header = (props) => {
  return (
    <header id="header" style={{
      position: 'relative',
      minHeight: '100vh',
      background: 'linear-gradient(135deg, rgba(44, 62, 80, 0.9), rgba(73, 220, 88, 0.8)), url("/img/intro-bg.jpg")',
      backgroundSize: 'cover',
      backgroundPosition: 'center',
      backgroundAttachment: 'fixed',
      display: 'flex',
      alignItems: 'center',
      overflow: 'hidden'
    }}>
      {/* Elementos decorativos animados */}
      <div style={{
        position: 'absolute',
        top: '20%',
        left: '10%',
        width: '100px',
        height: '100px',
        background: 'rgba(255,255,255,0.1)',
        borderRadius: '50%',
        animation: 'float 6s ease-in-out infinite'
      }}></div>
      <div style={{
        position: 'absolute',
        bottom: '30%',
        right: '15%',
        width: '150px',
        height: '150px',
        background: 'rgba(46, 204, 113, 0.2)',
        borderRadius: '50%',
        animation: 'float 8s ease-in-out infinite reverse'
      }}></div>
      
      <div className="intro" style={{ width: '100%', position: 'relative', zIndex: 2 }}>
        <div className="container">
          <div className="row">
            <div className="col-md-10 col-md-offset-1 intro-text" style={{ textAlign: 'center' }}>
             
              
              <h1 style={{
                fontSize: '4em',
                fontWeight: 'bold',
                color: 'white',
                textShadow: '3px 3px 6px rgba(0,0,0,0.5)',
                marginBottom: '30px',
                lineHeight: '1.2'
              }}>
                {props.data ? props.data.title : "Cargando..."}
              </h1>
              
              <div style={{
                width: '150px',
                height: '4px',
                background: 'linear-gradient(90deg, #3498db, #2ecc71)',
                margin: '0 auto 40px',
                borderRadius: '2px'
              }}></div>
              
              <p style={{
                fontSize: '1.4em',
                color: 'rgba(255,255,255,0.9)',
                textShadow: '2px 2px 4px rgba(0,0,0,0.5)',
                maxWidth: '800px',
                margin: '0 auto 50px',
                lineHeight: '1.6'
              }}>
                {props.data ? props.data.paragraph : "Cargando..."}
              </p>
              
              <div style={{ display: 'flex', justifyContent: 'center', gap: '20px', flexWrap: 'wrap' }}>
                <a
                  href="#primary-services"
                  className="btn page-scroll"
                  style={{
                    background: 'linear-gradient(135deg, #3498db, #2980b9)',
                    color: 'white',
                    padding: '15px 40px',
                    fontSize: '1.1em',
                    fontWeight: 'bold',
                    border: 'none',
                    borderRadius: '50px',
                    textDecoration: 'none',
                    boxShadow: '0 10px 30px rgba(52, 152, 219, 0.4)',
                    transition: 'all 0.3s ease',
                    textTransform: 'uppercase',
                    letterSpacing: '1px'
                  }}
                  onMouseEnter={(e) => {
                    e.target.style.transform = 'translateY(-3px)';
                    e.target.style.boxShadow = '0 15px 40px rgba(52, 152, 219, 0.6)';
                  }}
                  onMouseLeave={(e) => {
                    e.target.style.transform = 'translateY(0)';
                    e.target.style.boxShadow = '0 10px 30px rgba(52, 152, 219, 0.4)';
                  }}
                >
                  🚀 Nuestros Servicios
                </a>
                
                <a
                  href="#about"
                  className="btn page-scroll"
                  style={{
                    background: 'transparent',
                    color: 'white',
                    padding: '15px 40px',
                    fontSize: '1.1em',
                    fontWeight: 'bold',
                    border: '2px solid white',
                    borderRadius: '50px',
                    textDecoration: 'none',
                    transition: 'all 0.3s ease',
                    textTransform: 'uppercase',
                    letterSpacing: '1px'
                  }}
                  onMouseEnter={(e) => {
                    e.target.style.background = 'white';
                    e.target.style.color = '#2c3e50';
                    e.target.style.transform = 'translateY(-3px)';
                  }}
                  onMouseLeave={(e) => {
                    e.target.style.background = 'transparent';
                    e.target.style.color = 'white';
                    e.target.style.transform = 'translateY(0)';
                  }}
                >
                  📖 Conocer Más
                </a>
              </div>
              
              {/* Indicador de scroll */}
              <div style={{
                position: 'absolute',
                bottom: '30px',
                left: '50%',
                transform: 'translateX(-50%)',
                color: 'white',
                textAlign: 'center',
                animation: 'bounce 2s infinite'
              }}>
                <div style={{ fontSize: '0.9em', marginBottom: '10px' }}>Desliza hacia abajo</div>
                <div style={{ fontSize: '1.5em' }}>⬇</div>
              </div>
            </div>
          </div>
        </div>
      </div>
      
      {/* CSS para animaciones */}
      <style jsx>{`
        @keyframes float {
          0%, 100% { transform: translateY(0px); }
          50% { transform: translateY(-20px); }
        }
        @keyframes pulse {
          0%, 100% { transform: scale(1); }
          50% { transform: scale(1.05); }
        }
        @keyframes bounce {
          0%, 20%, 50%, 80%, 100% { transform: translateX(-50%) translateY(0); }
          40% { transform: translateX(-50%) translateY(-10px); }
          60% { transform: translateX(-50%) translateY(-5px); }
        }
      `}</style>
    </header>
  );
};
